import { Button, ButtonProps, Spinner } from "react-bootstrap";
import styled from "styled-components";

export const MainButton = ({
  className,
  disabled,
  isSubmitting,
  ...props
}: ButtonProps & { isSubmitting?: boolean }) => (
  <Button
    className={`${className || ""} d-block w-100 fw-bold fs-6`}
    size="lg"
    disabled={isSubmitting || disabled}
    {...props}
  >
    {isSubmitting ? (
      <>
        <Spinner size="sm" animation="border" /> {props.children}
      </>
    ) : (
      props.children
    )}
  </Button>
);

export const MainButtons = styled.div`
  display: flex;
  & > * + * {
    margin-left: 16px;
  }
`;

export const IconButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 1000px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  background: none;
  & > * {
    flex-shrink: 0;
  }
`;
